<template>
  <v-alert class="mt-3" color="info" type="info">
    We currently don’t have any offerings scheduled. However, if you or your
    group are interested in this topic, please
    <a
      :href="
        mailToHref({
          email: siteConfig.info_email,
          subject: 'New Training Offering'
        })
      "
      class="text-white"
      target="_blank"
      >email us</a
    >
    and we’ll be happy to discuss potential options!
  </v-alert>
</template>

<script setup>
import { usePageContext } from '#root/renderer/usePageContext'
import { mailToHref } from '#root/lib/utils'

const { siteConfig } = usePageContext()
</script>
